import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from 'src/app/screens/shared/banner/banner.component';
import { LazyloadDirective } from 'src/app/directives/lazyload.directive';
import { ButtonComponent } from 'src/app/screens/shared/button/button.component';
import { LoaderComponent } from 'src/app/screens/shared/loader/loader.component';
import { ScrollRevealDirective } from './directives/scroll-reveal.directive';



@NgModule({
  declarations: [
    BannerComponent,
    LazyloadDirective,
    ButtonComponent,
    LoaderComponent,
    ScrollRevealDirective
  ],
  imports: [
    CommonModule
  ],
  exports:[
    BannerComponent,
    LazyloadDirective,
    ButtonComponent,
    LoaderComponent
  ]
})
export class SharedModule { }
